// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__C9vZp","primary":"Banner_primary__F3XQT","warning":"Banner_warning__mTnxH","message":"Banner_message__cxfRp"};